<template>
  <section id="download" class="download section">
    <div class="container">
      <div class="section-header">
        <h2>立即下载</h2>
        <p>幸福输入法移动版现已推出，下载体验</p>
      </div>
      
      <div class="download-wrapper">
        <div class="shapes">
          <div class="shape shape-circle"></div>
          <div class="shape shape-star">★</div>
          <div class="shape shape-square"></div>
        </div>
        <div class="download-card">
          <div class="device-preview">
            <div class="phone-frame">
              <div class="phone-screen">
                <img src="../assets/images/phone-screen.jpg" alt="幸福输入法界面" class="phone-screen-img" />

              </div>
            </div>
          </div>
          <div class="download-content">
            <h3>Android 版</h3>
            <p>适用于 Android 6.0 及以上设备</p>
            <div class="download-info">
              <span class="version">v0.0.1</span>
              <span class="size">64 MB</span>
            </div>
            <a :href="apkDownloadUrl" class="btn btn-primary download-btn" download="com.hf.pinyin-v0.0.1.apk" @click="trackDownload">
              <span class="download-icon">↓</span>
              <span>立即下载</span>
            </a>
          </div>
        </div>
      </div>
      
      <div class="coming-soon">
        <p>iOS 版及桌面版本将陆续推出，敬请期待</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DownloadSection',
  data() {
    return {
      apkDownloadUrl: '/downloads/com.hf.pinyin.apk'
    }
  },
  methods: {
    trackDownload() {
      // 简单的下载跟踪
      console.log('APK download started');
      // 允许默认的链接行为继续
    }
  }
}
</script>

<style scoped>
.download {
  background-color: #f8f9fe;
  position: relative;
  overflow: hidden;
}

.download-wrapper {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
}

.shapes {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.shape {
  position: absolute;
}

.shape-circle {
  width: 30px;
  height: 30px;
  background: #FFC847;
  border-radius: 50%;
  top: 20%;
  left: 10%;
}

.shape-star {
  font-size: 24px;
  color: #6C63FF;
  top: 30%;
  right: 15%;
}

.shape-square {
  width: 20px;
  height: 20px;
  background: #FF6B8B;
  transform: rotate(45deg);
  bottom: 20%;
  left: 20%;
}

.download-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 15px 50px rgba(108, 99, 255, 0.1);
  position: relative;
  z-index: 1;
}

.device-preview {
  flex: 1;
  max-width: 200px;
  margin-right: 40px;
}

.phone-frame {
  background: #2A0E55;
  border-radius: 30px;
  padding: 10px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(42, 14, 85, 0.15);
}

.phone-screen {
  border-radius: 20px;
  padding: 5px;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-color: #f5f5f5;
}

.phone-screen-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 0;
}

.app-icon {
  width: 60px;
  height: 60px;
  background: white;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  position: relative;
  z-index: 1;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.app-icon span {
  font-size: 22px;
  font-weight: 800;
  color: #6A1B9A;
}

.app-name {
  color: white;
  font-weight: 600;
  font-size: 14px;
  position: relative;
  z-index: 1;
}

.download-content {
  flex: 2;
}

.download-content h3 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #333;
}

.download-content p {
  color: #666;
  margin-bottom: 20px;
}

.download-info {
  display: flex;
  margin-bottom: 25px;
  font-size: 14px;
  color: #6c757d;
}

.download-info .version {
  margin-right: 15px;
  padding-right: 15px;
  border-right: 1px solid #dee2e6;
}

.download-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 18px;
  gap: 10px;
}

.download-icon {
  font-size: 22px;
  font-weight: bold;
}

.coming-soon {
  text-align: center;
  margin-top: 40px;
  color: #6c757d;
  font-style: italic;
}

@media (max-width: 768px) {
  .download-card {
    flex-direction: column;
    padding: 30px;
  }
  
  .device-preview {
    margin-right: 0;
    margin-bottom: 30px;
    max-width: 280px;
    width: 100%;
  }
  
  .phone-screen {
    min-height: 350px;
  }
}

@media (max-width: 576px) {
  .phone-screen {
    min-height: 250;
  }
  
  .device-preview {
    max-width: 180px;
  }
  
  .app-icon {
    width: 50px;
    height: 50px;
  }
  
  .app-icon span {
    font-size: 18px;
  }
}
</style> 